import { render, staticRenderFns } from "./CabeceraModalDevolucionCrear.vue?vue&type=template&id=082f2b3f&scoped=true&"
import script from "./CabeceraModalDevolucionCrear.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalDevolucionCrear.vue?vue&type=script&lang=ts&"
import style0 from "./CabeceraModalDevolucionCrear.vue?vue&type=style&index=0&id=082f2b3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f2b3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('082f2b3f', component.options)
    } else {
      api.reload('082f2b3f', component.options)
    }
    module.hot.accept("./CabeceraModalDevolucionCrear.vue?vue&type=template&id=082f2b3f&scoped=true&", function () {
      api.rerender('082f2b3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Devoluciones/CabeceraModalDevolucionCrear.vue"
export default component.exports